import { addDays, localDate } from './format';

const weekday = new Intl.DateTimeFormat('de-DE', { weekday: 'long', timeZone: 'UTC' });

// compareLabel: Vergleichstag der Startseite lesbar – „gestern“ bzw. „am Samstag“ (nach Sonntag, Feiertagen usw.).
export function compareLabel(date?: string | null, today: string = localDate()): string {
  if (!date || date === addDays(today, -1)) return 'gestern';
  const [y = 1970, m = 1, d = 1] = date.split('-').map(Number);
  return `am ${weekday.format(new Date(Date.UTC(y, m - 1, d, 12)))}`;
}
